import type { ZodSchema, z } from 'zod';

import { schemas } from './__generated__api.ts';

export const apiSchema = {
    ...schemas,
} satisfies Record<keyof typeof schemas, ZodSchema>;

export type ApiDriverResponse = z.infer<typeof apiSchema.DriverResponse>;
export type ApiDriverEmbedded = z.infer<typeof apiSchema.DriverEmbedded>;
export type ApiDriversEmbeddedList = z.infer<typeof apiSchema.DriversEmbeddedList>;
